import { render, staticRenderFns } from "./verifyForm.vue?vue&type=template&id=0c4a4d52&scoped=true"
import script from "./verifyForm.vue?vue&type=script&lang=js"
export * from "./verifyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a4d52",
  null
  
)

export default component.exports